import React, { useEffect } from 'react'
import { SimpleTable, TableToolbar } from 'components/SimpleTable'
import ContentOverlayLoader from 'components/ContentOverlayLoader'
import { connect } from 'react-redux'
import module_group_relActions from '../../store/actions/module_group_rel'
import { getStateValue } from 'store/selectors'
import { useTabNavigation } from 'hooks/useTabNavigation'
import { useTranslation } from 'react-i18next'

const WizardCatalog = (props) => {
	const { t } = useTranslation()
	const { superAdmin, getModuleGroupRel, module_group_rels } = props
	const { openTab } = useTabNavigation()

	const logo =
		props.client?.sysCompanyImage?.logo_url ||
		props.user?.sysCompanyImage?.logo_url ||
		props.driver?.sys_company_data?.logo_url ||
		props.supplier?.sys_company_data?.logo_url
	const showLoader = false && !!logo

	useEffect(() => {
		getModuleGroupRel()
	}, [])

	return (
		<div className='PageContainer'>
			{showLoader && <ContentOverlayLoader active={true} text={t('Cargando...')} />}
			<TableToolbar
				title={t('Administrador de Wizard')}
				onAdd={() => openTab({ path: '/wizards_superAdmin/new', title: t('Nuevo Wizard') }, null, true)}
				onRefresh={() => getModuleGroupRel()}
			/>
			<SimpleTable
				tableId="wizard-catalog-main"
				rows={module_group_rels}
				serverSide={false}
				onRowClick={(row) => {
					const title = row.module_group || `Wizard ${row.id}`
					openTab({ path: `/wizards_superAdmin/${row.id}`, title }, null, true)
				}}
				columns={[
					{ width: 175, Header: t('Módulo'), accessor: 'module_group' },
					{ width: 100, Header: t('Visible'), accessor: 'isVisible', type: 'boolean' },
				]}
			/>
		</div>
	)
}

const mapDispatchToProps = (dispatch) => ({
	getModuleGroupRel: (options) => dispatch(module_group_relActions.getModuleGroupRel(options)),
})

const mapStateToProps = (state) => ({
	module_group_rels: getStateValue(state.module_group_rels.entities),
	superAdmin: state.app.superAdmin,
})

export default connect(mapStateToProps, mapDispatchToProps)(WizardCatalog)
